/** Lav et simpelt id, skal kun bruges til dom manipulation
 * og ikke noget data kritisk.
 */
export const uid = () => Date.now().toString(36) + Math.random().toString(36).substr(2);
